import { MarketNotifier } from '@goparrot-dashboard/shared-ui/src/providers/MarketNotificationProvider';
import { IntlStringType } from '../../../../i18n/src/providers/interface';

export const ssoLoginRedirectFailure = (notifyError: MarketNotifier, getIntlString: IntlStringType): void => {
  notifyError({
    text: getIntlString('error.ssoLoginError'),
  });
};
